var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 92,
    viewBox: "0 0 89 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.6958 74.5386L58.1863 41.1328L57.7891 11.0335L62.6809 10.9796C65.3705 10.9437 67.5366 8.6615 67.5005 5.89416C67.4644 3.14479 65.2261 0.898568 62.5546 0.934507L23.4383 1.45563C20.7487 1.4736 18.5826 3.77373 18.6187 6.5231C18.6548 9.29044 20.8751 11.5187 23.5647 11.4827L28.4564 11.4109L28.8536 41.5102L2.21046 75.6168C0.676136 77.5934 0.00825278 79.8217 0.0443546 82.014C0.15266 87.1893 4.17801 92.0052 9.95429 91.9333L78.3852 91.0348C84.1976 90.9629 88.0966 86.0572 88.0424 80.8819C88.0063 78.6716 87.2843 76.4793 85.6958 74.5386ZM64.847 60.8277C64.5221 61.0972 64.125 61.223 63.7279 61.223C63.1863 61.223 62.6629 60.9894 62.3199 60.5581L59.1791 56.6587C58.5653 55.868 58.6917 54.7539 59.4679 54.1249C60.2441 53.514 61.3813 53.6398 62.013 54.4125L65.1358 58.3119C65.7496 59.0846 65.6232 60.2167 64.847 60.8277ZM79.5946 79.2107C79.2697 79.4803 78.8726 79.606 78.4754 79.606C77.9339 79.606 77.4104 79.3724 77.0494 78.9232L66.7063 66.0389C66.0925 65.2662 66.2189 64.1341 66.9951 63.5051C67.7713 62.8942 68.9085 63.02 69.5403 63.7927L79.8834 76.677C80.4971 77.4676 80.3708 78.5997 79.5946 79.2107Z",
    fill: "#268BD3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLab);
export default __webpack_public_path__ + "static/media/lab.6c9fe4596bbe992f1a3b920b8fe68721.svg";
export { ForwardRef as ReactComponent };